import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Portfolio from './Portfolio';
import BlogList from './BlogList';
import BlogDetail from './BlogDetail';
import DownvoteDonations from './DownvoteDonations';
import { BlogProvider } from './contexts/BlogContext';
import { PlausibleProvider } from './contexts/PlausibleContext'; // Add this
import { PlausiblePageViewTracker } from './PlausiblePageViewTracker'; // Add this
import NotFound from './NotFound'; // Import the NotFound component

// ============================================
// MAINTENANCE MODE FLAG - Set to true to show error page
// ============================================
const MAINTENANCE_MODE = true;
// ============================================

// Fake error page for maintenance mode
const SiteDown = () => {
  return (
    <div style={{
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      background: '#f1f1f1',
      margin: 0,
      padding: '40px 20px',
      color: '#333',
      minHeight: '100vh',
      boxSizing: 'border-box'
    }}>
      <div style={{
        maxWidth: '600px',
        margin: '0 auto',
        background: '#fff',
        border: '1px solid #ccc',
        borderRadius: '3px',
        padding: '30px 40px'
      }}>
        <h1 style={{
          fontSize: '24px',
          fontWeight: 'normal',
          margin: '0 0 20px 0',
          color: '#333'
        }}>This site can't be reached</h1>
        <p style={{
          fontSize: '14px',
          lineHeight: '1.6',
          margin: '0 0 15px 0',
          color: '#666'
        }}>The connection was reset.</p>
        <p style={{
          fontSize: '14px',
          lineHeight: '1.6',
          margin: '0 0 15px 0',
          color: '#666'
        }}>Try:</p>
        <ul style={{ fontSize: '14px', color: '#666', marginBottom: '15px' }}>
          <li>Checking the connection</li>
          <li>Checking the proxy and the firewall</li>
        </ul>
        <div style={{
          fontFamily: 'monospace',
          background: '#f8f8f8',
          padding: '15px',
          border: '1px solid #ddd',
          margin: '20px 0',
          fontSize: '12px',
          color: '#999',
          overflowX: 'auto'
        }}>
          ERR_CONNECTION_RESET
        </div>
        <hr style={{
          border: 'none',
          borderTop: '1px solid #eee',
          margin: '25px 0'
        }} />
        <p style={{
          fontSize: '11px',
          color: '#999'
        }}>
          If you are the owner of this website, please contact your hosting provider.
        </p>
      </div>
    </div>
  );
};

// Since we need to use a hook (useLocation) inside the Router,
// we need to create a wrapper component
const AppContent = () => {
  const [activeSection, setActiveSection] = useState('home');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('section');
      const scrollPosition = window.scrollY + 200;

      sections.forEach(section => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        const sectionId = section.getAttribute('id');

        if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
          // setActiveSection(sectionId);
        }
      });

      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <BlogProvider>
      <PlausiblePageViewTracker />
      <div className={`portfolio ${isScrolled ? 'scrolled' : ''}`}>
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/downvote-donations" element={<DownvoteDonations />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </BlogProvider>
  );
};

function App() {
  // If maintenance mode is on, show the fake error page
  if (MAINTENANCE_MODE) {
    return <SiteDown />;
  }

  return (
    <PlausibleProvider domain="julp.me"> {/* Replace with your actual domain */}
      <Router>
        <AppContent />
      </Router>
    </PlausibleProvider>
  );
}
export default App;
